import classNames from 'classnames';

import {EllipsisTooltip} from '@macmillanplatform/ui-core';

import {
  ORDER_SHIPPING_STATUS_COLORS,
  TRACKING_STATUSES,
  TRACKING_STATUS_COLORS,
} from '../../../../constants';
import {SectionTitleItem, SectionTitleProps} from './types';

import {withFallback} from '../../../../helpers';

import './index.css';

export type {SectionTitleItem, SectionTitleProps};

const getValueModifier = (item: SectionTitleItem) =>
  item.trackingStatus && TRACKING_STATUS_COLORS[item.trackingStatus];

const SectionTitle = (props: SectionTitleProps) => {
  const {items = [], shippingStatus} = props;

  const shippingModifier = ORDER_SHIPPING_STATUS_COLORS[shippingStatus];

  return (
    <div className="SectionTitle">
      <div
        className={classNames(
          'SectionTitle__icon-container',
          shippingModifier &&
            `SectionTitle__icon-container--${shippingModifier}`
        )}
      >
        <i className="SectionTitle__icon fa-solid fa-truck-fast" />
        <span className="SectionTitle__status">
          {withFallback(shippingStatus)}
        </span>
      </div>
      {items.map((item, idx) => {
        const valueModifier = getValueModifier(item);
        const isDelivered = item.trackingStatus === TRACKING_STATUSES.DELIVERED;
        const valueClassName = classNames(
          'SectionTitle__value',
          item.valueBold && 'SectionTitle__value--bold'
        );

        return (
          <div
            key={idx}
            className={classNames(
              'SectionTitle__cell',
              valueModifier && `SectionTitle__cell--${valueModifier}`
            )}
          >
            <span className="SectionTitle__label">{item.label}:</span>
            {item.withoutTooltip ? (
              <span className="SectionTitle__copy">{item.value}</span>
            ) : (
              <EllipsisTooltip title={item.value} className={valueClassName}>
                <span>{item.value}</span>
              </EllipsisTooltip>
            )}
            {isDelivered && (
              <i className="fa-solid fa-circle-check SectionTitle__check-icon" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SectionTitle;
